module.exports = __webpack_public_path__ + "static/jordan-cb841b3624e21b3db820222b5236c35c.jpg";